define('tracks/jump-type-settings',["require", "exports", "../dom", "../util/http", "../views/autocomplete", "../views/text-setting"], function (require, exports, dom_1, http_1, autocomplete_1, text_setting_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.init = void 0;
    var jumpTypes = ["BASE", "Skydive", "PG"];
    function init(trackId) {
        var typeElement = (0, dom_1.q)(".text-setting.type")[0];
        if (!typeElement)
            return;
        // Initialize text setting component
        var textSetting = new text_setting_1.TextSetting({
            element: typeElement,
            selectMode: text_setting_1.TextSettingMode.SelectAll,
            closeOnBlur: false,
            save: function (jumpType) {
                if (jumpType === "" || jumpTypes.indexOf(jumpType) >= 0) {
                    return (0, http_1.postJson)("/tracks/" + trackId + "/type", jumpType);
                }
                else {
                    return Promise.reject("Invalid jump type: " + jumpType);
                }
            }
        });
        // Initialize jump type autocomplete
        var input = document.getElementById("jump-type-input");
        if (input) {
            var ac = new autocomplete_1.Autocomplete({
                input: input,
                items: jumpTypes,
                minLength: 0,
                display: function (jumpType) { return jumpType; },
                filter: function () { return true; },
                value: function (jumpType) { return jumpType; }
            });
            ac.updates.subscribe(function (jumpType) {
                textSetting.commit(jumpType);
            });
        }
    }
    exports.init = init;
});
//# sourceMappingURL=/assets/javascripts/tracks/jump-type-settings.js.map;
